/**
 * نصوص التنقل: الشريط العلوي، القائمة الجانبية، قائمة «سجل معنا» ورابط
 * «حقوق الصور» في التذييل. تُستخدم عبر useTranslation('nav') أو بالبادئة nav:.
 *
 * المصطلحات تتبع docs/arabic-glossary.md: «مسوّق ووسيط عقاري»، «الباقات»،
 * «صفقات 24»، والأرقام الغربية. يجب أن تطابق مفاتيح en/nav.ts هذا الملف تماماً.
 */
const nav = {
  skipToContent: 'تخطَّ إلى المحتوى',

  menu: {
    open: 'فتح القائمة',
    close: 'إغلاق القائمة',
    title: 'القائمة',
  },

  // عناوين الشريط العلوي
  top: {
    rent: 'للإيجار',
    buy: 'للبيع',
    invest: 'للاستثمار',
    nonSaudi: 'تملّك لغير السعوديين',
    findPro: 'ابحث عن',
    services: 'خدماتنا',
  },

  // قوائم «للإيجار» و«للبيع»
  browse: {
    all: 'الكل',
    residential: 'سكني',
    commercial: 'تجاري',
    rentAllDesc: 'تصفّح كل المعروض للإيجار',
    rentResidentialDesc: 'منازل وشقق سكنية',
    buyAllDesc: 'تصفّح كل المعروض للبيع',
    buyResidentialDesc: 'منازل وشقق وأراضٍ سكنية',
    commercialDesc: 'مكاتب ومحلات ومستودعات وأكثر',
  },

  // قائمة «للاستثمار»
  invest: {
    hub: 'منصة المستثمرين',
    hubDesc: 'حيث يلتقي المطوّرون بالمستثمرين',
    specialDeals: 'صفقات خاصة',
    specialDealsDesc: 'فرص حصرية للمشتركين',
    licensedProjects: 'الاستثمار في مشاريع مرخّصة',
    licensedProjectsDesc: 'استثمر في مشاريع مرخّصة للبيع أو الإيجار',
    contributions: 'المساهمات العقارية',
    contributionsDesc: 'ساهم بتمويل المشاريع المرخّصة',
    requests: 'طلبات الاستثمار العقاري',
    requestsDesc: 'خاصة بالمطوّرين الذين يبحثون عن فرص للاستثمار',
    list: 'اعرض عقارك للاستثمار',
    listDesc: 'اعرض عقارك على المستثمرين',
  },

  // قائمة «ابحث عن»
  findPro: {
    brokers: 'مسوّق ووسيط عقاري',
    brokersDesc: 'وسطاء ومسوّقون موثوقون',
    developers: 'مطوّرون عقاريون',
    developersDesc: 'شركات التطوير العقاري',
    propertyManagement: 'إدارة أملاك',
    propertyManagementDesc: 'إدارة أملاك المالكين',
    facilitiesManagement: 'إدارة مرافق',
    facilitiesManagementDesc: 'تشغيل وصيانة المرافق',
    appraisers: 'مقيّم عقاري',
    appraisersDesc: 'تقييم العقارات',
    brokersMap: 'خريطة الوسطاء',
    brokersMapDesc: 'الخبراء القريبين منك',
  },

  // قائمة «خدماتنا» وبطاقة «خدماتنا» في القائمة الجانبية
  services: {
    listPropertyDesc: 'أضف عقارك للبيع أو الإيجار',
    postRequestDesc: 'انشر طلبك ليصلك العرض',
    subscriptionsDesc: 'خطط وأسعار النشر',
    marketTools: 'مؤشرات السوق',
    marketToolsDesc: 'أسعار وإيجارات من صفقات مسجّلة',
    proServices: 'الخدمات المهنية',
    requestsBoard: 'لوحة الطلبات',
    addons: 'الإضافات',
    bundles: 'الباقات',
    coins: 'النقاط',
    myAddons: 'إضافاتي',
  },

  // زر «سجل معنا» وقائمته
  register: {
    cta: 'سجل معنا',
    createAccount: 'إنشاء حساب',
    createAccountDesc: 'حساب مجاني لحفظ المفضلة ومتابعة طلباتك',
    asProfessional: 'سجّل كمهني',
    developer: 'مطوّر عقاري',
    developerDesc: 'سوّق وطوّر المشاريع',
    broker: 'مسوّق ووسيط عقاري',
    brokerDesc: 'أضف وسوّق العقارات',
    propertyManagement: 'إدارة أملاك',
    propertyManagementDesc: 'أدر أملاك المالكين',
    facilitiesManagement: 'إدارة مرافق',
    facilitiesManagementDesc: 'تشغيل وصيانة المرافق',
    appraiser: 'مقيّم عقاري',
    appraiserDesc: 'تقييم العقارات',
  },

  signIn: 'تسجيل الدخول',

  // أسماء اللغات بلغتها الأصلية (القيمة نفسها في الملفين)
  language: {
    ar: 'العربية',
    en: 'English',
  },

  account: {
    grow: 'طوّر حسابك',
    menu: 'قائمة الحساب',
  },

  enquiriesUnread: 'الاستفسارات، {{n}} غير مقروءة',

  sidebar: {
    guestTitle: 'سجّل الدخول لتجربة مخصّصة',
    guestBody: 'احفظ عقاراتك المفضلة وتابع طلباتك وإعلاناتك من مكان واحد.',
    noAccount: 'ليس لديك حساب؟',
    properties: {
      title: 'العقارات',
      subtitle: 'للإيجار والبيع والاستثمار',
    },
    // العنوان من common:navigation.postRequest («أضف طلبك»)
    postRequest: {
      subtitle: 'انشر طلبك ليصلك العرض',
    },
    services: {
      title: 'خدماتنا',
      subtitle: 'مؤشرات السوق والاشتراكات والإضافات',
    },
    findPro: {
      title: 'ابحث عن',
      subtitle: 'وسطاء ومطوّرون ومختصون عقاريون',
    },
    registerPro: {
      title: 'سجل معنا كمهني',
      subtitle: 'للمطوّرين والوسطاء والمختصين',
    },
    account: {
      title: 'حسابي',
      subtitle: 'ملفك وعقاراتك وطلباتك',
    },
    help: {
      title: 'المساعدة والدعم',
      subtitle: 'من نحن، تواصل معنا، الشكاوى',
      liveChat: 'الدعم المباشر',
    },
    comingSoon: 'قريباً',
    language: 'اللغة',
    theme: 'المظهر',
    signOut: 'تسجيل الخروج',
  },

  badges: {
    broker: 'وسيط',
    company: 'شركة',
    individual: 'فرد',
    developer: 'مطوّر',
  },

  theme: {
    switchToLight: 'التبديل إلى الوضع الفاتح',
    switchToDark: 'التبديل إلى الوضع الداكن',
  },

  // تنبيهات زر «أضف عقارك» للوسطاء والشركات (نُقلت كما هي من Navigation)
  listProperty: {
    falRejected: 'تم رفض ترخيص الفال الخاص بك. يرجى إعادة التقديم من إعدادات حسابك.',
    falPending: 'ترخيص الفال الخاص بك قيد المراجعة. سيتم إشعارك عند اعتماده.',
  },

  footer: {
    photoCredits: 'حقوق الصور',
  },
};

export default nav;
